/* eslint-disable max-len */
import React from 'react';

interface IMasterCardProps {
    width?: number;
    height?: number;
}

const MasterCard: React.FC<IMasterCardProps> = ({width = 30, height = 18}) => {

    return (
        <svg width={width} height={height} viewBox="0 0 30 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z" fill="#899696"/>
            <path opacity="0.4" d="M21 18C25.9706 18 30 13.9706 30 9C30 4.02944 25.9706 0 21 0C16.0294 0 12 4.02944 12 9C12 13.9706 16.0294 18 21 18Z" fill="#899696"/>
            <g opacity="0.4">
                <path fillRule="evenodd" clipRule="evenodd" d="M15.0633 15.8645C16.9496 14.2021 18.1383 11.7763 18.1383 9.0748C18.1383 6.37337 16.9496 3.9476 15.0633 2.28516C13.177 3.9476 11.9883 6.37337 11.9883 9.0748C11.9883 11.7763 13.177 14.2021 15.0633 15.8645Z" fill="#899696"/>
            </g>
        </svg>
    );
};

export default MasterCard;